import {
  ResponsiveProp,
  isResponsiveProp,
} from "@faire/web--source/slate/Theme/ResponsiveProp";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";

export const useResponsiveProp = <T>(prop: ResponsiveProp<T>): T => {
  return useResponsiveValue(
    isResponsiveProp(prop) ? prop : { mobileAndAbove: prop }
  );
};
